// extracted by mini-css-extract-plugin
export var activeFilterButton = "_pj-c";
export var backButton = "_pj-4";
export var backIcon = "_pj-5";
export var chevronShortcut = "_pj-6";
export var container = "_pj-1";
export var editor = "_pj-8";
export var editorWrapper = "_pj-7";
export var prefix = "_pj-2";
export var searchIcon = "_pj-3";
export var suffix = "_pj-9";
export var suffixContent = "_pj-a";
export var suffixText = "_pj-b";
export var wrapper = "_pj-0";